import type { ReactNode } from "react";

/**
 * Green-check item. `chip` = pill (try-it features); `inline` = bare row
 * (CTA reassurances, notes). Recurs across many sections.
 */
export default function CheckItem({
  children,
  variant = "inline",
  tone = "default",
  className = "",
}: {
  children: ReactNode;
  variant?: "inline" | "chip";
  /** `light` = light-on-drenched-surface styling (pink/dark bands). */
  tone?: "default" | "light";
  className?: string;
}) {
  const chip =
    variant === "chip"
      ? "rounded-full border border-line bg-surface-2 px-[11px] py-[5px] text-[12.5px]"
      : "";
  const text = tone === "light" ? "text-white/85" : "text-muted";
  const check = tone === "light" ? "text-white" : "text-data-green";

  return (
    <span className={`flex items-center gap-[7px] ${text} ${chip} ${className}`}>
      <span className={`shrink-0 ${check}`}>✓</span>
      {children}
    </span>
  );
}
